import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  badge: {
    border: 'var(--border-neutral-thin)',
    fontSize: '10px',
    fontWeight: 100,
    padding: '2px',
    borderRadius: 'var(--border-radius-xs)',
    marginRight: '5px',
    backgroundColor: 'var(--color-neutral-400)'
  }
}))

function PurposeBadge ({ enabled, purpose }) {
  const classes = useStyles()

  if (!enabled) return <div>Disabled</div>

  return (
    <span className={classes.badge}>
      {purpose}
    </span>
  )
}

PurposeBadge.propTypes = {
  enabled: PropTypes.bool,
  purpose: PropTypes.string
}

export default PurposeBadge
